import { Link } from 'react-router-dom';
import Header from '../../home/components/Header';
import Footer from '../../home/components/Footer';

export default function CommercialService() {
  const services = [
    {
      icon: 'ri-building-line',
      title: 'Bureaux & Espaces de Travail',
      description: 'Entretien professionnel de vos locaux d\'entreprise',
      price: 'À partir de 30€/h',
      features: [
        'Nettoyage des postes de travail',
        'Salles de réunion et espaces communs',
        'Accueil et zones d\'attente',
        'Sanitaires professionnels',
        'Sols et surfaces vitrées',
        'Vide des corbeilles et recyclage'
      ]
    },
    {
      icon: 'ri-store-line',
      title: 'Commerces & Boutiques',
      description: 'Services adaptés aux espaces commerciaux',
      price: 'Sur devis',
      features: [
        'Vitrines et devantures impeccables',
        'Espaces clients et zones de vente',
        'Zones de stockage et réserves',
        'Sanitaires publics',
        'Sols haute fréquentation',
        'Interventions en horaires adaptés'
      ]
    },
    {
      icon: 'ri-shield-keyhole-line',
      title: 'Désinfection Professionnelle',
      description: 'Traitement sanitaire complet et certifié',
      price: 'À partir de 150€',
      features: [
        'Produits certifiés et homologués',
        'Désinfection surfaces de contact',
        'Traitement des systèmes d\'aération',
        'Certification et documentation',
        'Protocoles sanitaires COVID',
        'Suivi et contrôle qualité'
      ]
    }
  ];

  const sectors = [
    {
      icon: 'ri-hospital-line',
      title: 'Secteur Médical',
      description: 'Nettoyage spécialisé selon normes sanitaires'
    },
    {
      icon: 'ri-school-line',
      title: 'Établissements Scolaires',
      description: 'Entretien adapté aux environnements éducatifs'
    },
    {
      icon: 'ri-restaurant-line',
      title: 'Restauration',
      description: 'Solutions pour cuisines et espaces de restauration'
    },
    {
      icon: 'ri-shopping-bag-line',
      title: 'Commerce de Détail',
      description: 'Maintien de l\'image de marque par la propreté'
    }
  ];

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-gray-50/30">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative py-24 bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(34, 197, 94, 0.8), rgba(22, 163, 74, 0.8)), url('https://readdy.ai/api/search-image?query=Professional%20commercial%20cleaning%20service%20team%20working%20in%20modern%20office%20building%20environment%20with%20cleaning%20equipment%2C%20bright%20corporate%20interior%2C%20business%20atmosphere%2C%20green%20and%20white%20color%20scheme%2C%20high%20quality%20photography%2C%20spotless%20clean%20surfaces%2C%20professional%20cleaning%20crew&width=1920&height=800&seq=commercial-hero&orientation=landscape')`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <div className="mb-6">
            <Link to="/" className="inline-flex items-center text-green-200 hover:text-white transition-colors cursor-pointer">
              <i className="ri-arrow-left-line mr-2"></i>
              Retour à l'accueil
            </Link>
          </div>
          
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            Nettoyage Commercial
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-4xl mx-auto">
            Des solutions professionnelles pour maintenir vos locaux impeccables
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={scrollToContact}
              className="bg-white text-green-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calculator-line mr-2"></i>
              Devis Entreprise
            </button>
            <button
              onClick={() => window.location.href = 'tel:+14384081200'}
              className="border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-green-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              438 408 1200
            </button>
          </div>
        </div>
      </section>

      {/* Services détaillés */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Nos Services Commerciaux
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Solutions sur mesure pour tous types d\'entreprises et commerces
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div key={index} className="bg-gray-50 rounded-xl overflow-hidden hover:shadow-lg transition-shadow">
                <div 
                  className="h-48 bg-cover bg-center relative"
                  style={{
                    backgroundImage: `url('https://readdy.ai/api/search-image?query=Professional%20commercial%20cleaning%20service%20$%7Bservice.title.toLowerCase%28%29%29%20in%20modern%20office%20building%20environment%2C%20green%20and%20white%20color%20scheme%2C%20high%20quality%20photography%2C%20business%20atmosphere%2C%20spotless%20clean%20surfaces%2C%20professional%20equipment&width=600&height=400&seq=commercial-detail-${index}&orientation=landscape')`
                  }}
                >
                  <div className="absolute inset-0 bg-green-600/20"></div>
                  <div className="absolute top-4 left-4 w-12 h-12 bg-green-600 rounded-full flex items-center justify-center">
                    <i className={`${service.icon} text-2xl text-white`}></i>
                  </div>
                </div>
                
                <div className="p-6">
                  <div className="flex justify-between items-start mb-4">
                    <h3 className="text-2xl font-bold text-gray-900">{service.title}</h3>
                    <span className="text-lg font-semibold text-green-600">{service.price}</span>
                  </div>
                  
                  <p className="text-gray-600 mb-6">{service.description}</p>
                  
                  <ul className="space-y-3 mb-6">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start">
                        <i className="ri-check-line text-green-500 mr-3 mt-1"></i>
                        <span className="text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  
                  <button
                    onClick={scrollToContact}
                    className="w-full bg-green-600 text-white py-3 rounded-lg font-semibold hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Demander un devis
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Secteurs d'activité */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Secteurs d'Activité
            </h2>
            <p className="text-xl text-gray-600">
              Nous intervenons dans tous les secteurs professionnels
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {sectors.map((sector, index) => (
              <div key={index} className="text-center bg-white rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${sector.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-lg font-semibold mb-3">{sector.title}</h3>
                <p className="text-gray-600 text-sm">{sector.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}